.processingIndicator {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
  background-color: color-mix(in oklch, var(--background) 95%, transparent);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 12px 16px;
  box-shadow: 0 4px 12px hsl(0 0% 0% / 0.1);
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;
  animation: slideIn 0.3s ease-out;
}

/* Dark mode - using global .dark class on html element */
:global(.dark) .processingIndicator {
  background-color: color-mix(in oklch, var(--card) 95%, transparent);
  border-color: var(--border);
  box-shadow: 0 4px 12px hsl(0 0% 0% / 0.3);
}

.content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--border);
  border-top: 2px solid var(--success);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

:global(.dark) .spinner {
  border-color: var(--border);
  border-top-color: var(--success-soft);
}

.appIcon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.message {
	font-size: 0.875rem;
	font-weight: 500;
	color: var(--foreground);
	white-space: nowrap;
}

:global(.dark) .message {
  color: var(--foreground);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes slideIn {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
